/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataSourceDto } from '../../models/data-source-dto';
import { UpdateDataSourceRequest } from '../../models/update-data-source-request';

export interface DatasourcesDataSourceIdPut$Plain$Params {
  dataSourceId: string;
      body?: UpdateDataSourceRequest
}

export function datasourcesDataSourceIdPut$Plain(http: HttpClient, rootUrl: string, params: DatasourcesDataSourceIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DataSourceDto>> {
  const rb = new RequestBuilder(rootUrl, datasourcesDataSourceIdPut$Plain.PATH, 'put');
  if (params) {
    rb.path('dataSourceId', params.dataSourceId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataSourceDto>;
    })
  );
}

datasourcesDataSourceIdPut$Plain.PATH = '/datasources/{dataSourceId}';
